import ModalStep from '../enums/modalStep';

const progressBarSteps = new Map();
progressBarSteps.set(ModalStep.DateTimeSelection, 0);
progressBarSteps.set(ModalStep.TourConfiguration, 1);
progressBarSteps.set(ModalStep.TermsAndConditions, 1);
progressBarSteps.set(ModalStep.SignIn, 2);
progressBarSteps.set(ModalStep.SignUp, 2);
progressBarSteps.set(ModalStep.PhoneVerification, 2);
progressBarSteps.set(ModalStep.IdentityVerification, 3);
progressBarSteps.set(ModalStep.CreditCardVerification, 3);
progressBarSteps.set(ModalStep.IframeVerification, 3);
progressBarSteps.set(ModalStep.VerificationInProgress, 3);
progressBarSteps.set(ModalStep.Questions, 4);
progressBarSteps.set(ModalStep.Confirmation, 5);

/**
 * Retrieves the progress index corresponding to a given step.
 *
 * @param {string} step - The step identifier for which to retrieve the progress index.
 * @returns {number} The progress index associated with the step. Returns 0 if the step is not found.
 */
const getProgressIndexByStep = (step) => {
  const index = progressBarSteps.get(step);

  if (index === undefined) {
    return 0;
  }

  return index;
};

export default getProgressIndexByStep;
